import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { FC } from 'react';
import { MonetizationTariff } from 'types/enums';
import styles from './style.module.scss';

interface Props {
  isActive?: boolean;
  tariff: MonetizationTariff;
  isPartialPayments?: boolean;
}

const Badge: FC<Props> = ({ isActive, tariff, isPartialPayments }) => {
  const t = useTranslations();

  return (
    <div
      className={classNames(styles.badge, {
        [styles.badge__standard]:
          !isPartialPayments && isActive && tariff === MonetizationTariff.Standard,
        [styles.badge__premium]:
          !isPartialPayments && isActive && tariff === MonetizationTariff.Premium,
        [styles.badge__partialPayment]: isPartialPayments,
      })}>
      {isPartialPayments ? (
        <div className={styles.partialPayment}>
          <Image src='/icons/warning.svg' width={12} height={12} alt='warning' />
          <span className={styles.partialPayment__text}>{t('pending_payment')}</span>
        </div>
      ) : isActive ? (
        t('active')
      ) : (
        t('no_active')
      )}
    </div>
  );
};

export default Badge;
